import { useEffect } from 'react';

/**
 * Warns the user about unsaved changes on hard reload / tab close while a
 * dirty form is open. In-app navigation (tab switches) is guarded in-component
 * by the editor (it intercepts tab clicks and opens a ConfirmDialog) — this
 * hook covers only the `beforeunload` (browser-level) path, since the app is
 * mounted under a plain <BrowserRouter> where react-router's `useBlocker` is
 * unavailable.
 */
export function useUnsavedGuard(isDirty: boolean): void {
  useEffect(() => {
    if (!isDirty) return;
    function handleBeforeUnload(e: BeforeUnloadEvent) {
      e.preventDefault();
      // Legacy browsers require returnValue to be set.
      e.returnValue = '';
    }
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [isDirty]);
}
